import {
  instoreform,
  setupStorePickupForm,
} from "./modules/in-store-pickup-form";
import {
  phoneorderform,
  setupPhoneOrderForm,
} from "./modules/phone-order-form";
import { Shortcuts } from "shortcuts";

/* eslint-disable no-var */
// setup on aspx page using code injection.
declare var phoneOrderFormIds: phoneorderform;
declare var inStoreFormIds: instoreform;
/* eslint-enable no-var */

jQuery().ready(function () {
  setupPhoneOrderForm(phoneOrderFormIds);
  setupStorePickupForm(inStoreFormIds);
});

const shortcuts = new Shortcuts();

shortcuts.add([
  {
    shortcut: "CmdOrCtrl+Shift+H CmdOrCtrl+Shift+S",
    handler: () => {
      const elements = [
        document.getElementById(phoneOrderFormIds.openButton) as HTMLElement,
        document.getElementById(inStoreFormIds.openButton) as HTMLElement,
      ];

      elements.forEach((el) => {
        if (el) {
          el.style.display = "inline-block";
        }
      });

      return true;
    },
  },
]);
